export enum DeviceType {
  Desktop,
  Mobile,
}
